// src/admin/AdminLayout.js
import React from "react";
import AdminDashboard from "./AdminDashboard";
import { motion } from "framer-motion";

export default function AdminLayout() {
  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    setTimeout(() => {
      window.location.href = "/admin/login";
    }, 100);
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
      backgroundAttachment: "fixed",
      padding: "0",
      margin: "0",
      color: "white",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      overflow: "hidden",
    }}>
      {/* HEADER PREMIUM */}
      <motion.header
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        style={{
          background: "linear-gradient(90deg, rgba(15,23,42,0.95) 0%, rgba(30,41,59,0.95) 100%)",
          backdropFilter: "blur(20px)",
          borderBottom: "2px solid rgba(251,191,36,0.3)",
          padding: "1.5rem 2rem",
          boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          maxWidth: "1400px",
          margin: "0 auto",
        }}>
          {/* LOGO SIDE */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              cursor: "pointer",
            }}
          >
            <div style={{
              width: "50px",
              height: "50px",
              background: "linear-gradient(135deg, #fbbf24, #f59e0b)",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.5rem",
              fontWeight: "700",
              boxShadow: "0 8px 25px rgba(251,191,36,0.3)",
            }}>
              ✂️
            </div>
            <div>
              <h1 style={{
                fontSize: "1.6rem",
                fontWeight: "700",
                margin: "0",
                background: "linear-gradient(90deg, #fbbf24, #f59e0b)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                letterSpacing: "0.5px",
              }}>
                NewStyle23
              </h1>
              <p style={{
                fontSize: "0.75rem",
                margin: "0.2rem 0 0 0",
                opacity: 0.7,
                color: "#cbd5e1",
              }}>
                Agenda Premium
              </p>
            </div>
          </motion.div>

          {/* LOGOUT BUTTON */}
          <motion.button
            whileHover={{ scale: 1.05, boxShadow: "0 15px 35px rgba(239,68,68,0.4)" }}
            whileTap={{ scale: 0.95 }}
            onClick={handleLogout}
            style={{
              padding: "0.75rem 1.8rem",
              background: "linear-gradient(135deg, #ef4444, #dc2626)",
              color: "white",
              border: "none",
              borderRadius: "50px",
              cursor: "pointer",
              fontWeight: "700",
              fontSize: "0.95rem",
              boxShadow: "0 10px 30px rgba(239,68,68,0.3)",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            🚪 Cerrar sesión
          </motion.button>
        </div>
      </motion.header>

      {/* MAIN CONTENT */}
      <main style={{
        padding: "2rem",
        maxWidth: "1400px",
        margin: "0 auto",
        width: "100%",
      }}>
        {/* DECORATIVE BACKGROUND ELEMENTS */}
        <div style={{
          position: "fixed",
          top: "10%",
          left: "5%",
          width: "300px",
          height: "300px",
          background: "radial-gradient(circle, rgba(251,191,36,0.1) 0%, transparent 70%)",
          borderRadius: "50%",
          pointerEvents: "none",
          zIndex: 0,
        }} />
        <div style={{
          position: "fixed",
          bottom: "10%",
          right: "5%",
          width: "300px",
          height: "300px",
          background: "radial-gradient(circle, rgba(34,197,94,0.1) 0%, transparent 70%)",
          borderRadius: "50%",
          pointerEvents: "none",
          zIndex: 0,
        }} />

        {/* CONTENT WRAPPER */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          style={{
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* TITLE SECTION */}
          <div style={{
            marginBottom: "2.5rem",
          }}>
            <h2 style={{
              fontSize: "2.2rem",
              fontWeight: "700",
              margin: "0 0 0.5rem 0",
              background: "linear-gradient(90deg, #fbbf24, #f59e0b, #fbbf24)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}>
              📋 Gestiona tus Citas
            </h2>
            <p style={{
              fontSize: "1rem",
              opacity: 0.7,
              margin: "0",
              color: "#cbd5e1",
            }}>
              Control total de tu agenda · Confirmaciones y cancelaciones en tiempo real
            </p>
          </div>

          {/* BOOKINGS CONTAINER */}
          <div style={{
            background: "linear-gradient(135deg, rgba(15,23,42,0.8) 0%, rgba(30,41,59,0.8) 100%)",
            backdropFilter: "blur(10px)",
            borderRadius: "20px",
            border: "1px solid rgba(251,191,36,0.2)",
            padding: "2rem",
            boxShadow: "0 20px 60px rgba(0,0,0,0.4), inset 0 1px 0 rgba(251,191,36,0.1)",
          }}>
            <AdminDashboard />
          </div>
        </motion.div>

        {/* FOOTER INFO */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          style={{
            textAlign: "center",
            marginTop: "3rem",
            opacity: 0.5,
            fontSize: "0.85rem",
          }}
        >
          <p>🔒 Tus datos están protegidos · Actualizado en tiempo real</p>
        </motion.div>
      </main>
    </div>
  );
}